import { useCallback, useState } from 'react'
import { BazaarvoiceReviewSortKey, CustomerReview } from 'shared-types'

import { Client } from '~/customClients/client'
import { useSession } from '~/hooks/useSession'

export function useReviews(sku: string | undefined, limit: number) {
  const { session } = useSession()
  const [reviews, setReviews] = useState<CustomerReview[]>([])
  const [total, setTotal] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const fetchReviews = useCallback(async (page: number, sort?: BazaarvoiceReviewSortKey) => {
    if (!sku) {
      return
    }

    try {
      setIsLoading(true)
      const result = await Client.reviews.getReviews(sku, session, limit, page, sort)
      setReviews(result.reviews)
      setTotal(result.total)
      setTotalPages(result.totalPages)
    } finally {
      setIsLoading(false)
    }
  }, [sku, session, limit])

  const submitFeedback = useCallback(async (contentId: string, isPositive: boolean): Promise<boolean> => {
    return Client.reviews.submitReviewFeedback(contentId, isPositive, session)
  }, [session])

  return { reviews, total, totalPages, isLoading, fetchReviews, submitFeedback }
}
